import React, { FC } from "react";

export type ImgRigthLoginProps = {
  src: string;
};

export const ImgRigthLogin: FC<ImgRigthLoginProps> = ({ src }) => {
  return (
    <img
      alt=""
      src={src}
      className="absolute inset-0 h-full w-full object-left object-cover select-none pointer-events-none"
      draggable="false"
    />
  );
};
